import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FiPower,
  FiEdit,
  FiTrash2,
  FiPlus,
  FiDollarSign,
  FiActivity,
  FiGrid,
  FiImage,
  FiCheckCircle,
  FiTrendingUp,
} from "react-icons/fi";
import { useToast, Spinner } from "@chakra-ui/react";
import ConfirmModal from "../components/ConformModel/ConfirmModal";
import { IoSearch, IoClose } from "react-icons/io5";
import { getUserRole } from "../components/utilities/getUserRole";
const CoinPackages = () => {
  const [loading, setLoading] = useState(true);
  const [packages, setPackages] = useState([]);
  const [modalOpen, setModalOpen] = useState(false); // add/edit modal
  const [rateModalOpen, setRateModalOpen] = useState(false); // change rate modal
  const [editingId, setEditingId] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTimeoutId, setSearchTimeoutId] = useState(null);
  const [frameToDelete, setFrameToDelete] = useState(null);

  const [Chatstats, setChatStats] = useState(null);
  const [conversionRate, setConversionRate] = useState(10); // rupee -> coins, default 1:10
  const [form, setForm] = useState({
    name: "",
    coins: "",
    originalPrice: "",
    discountPrice: "",
    bonusCoins: 0,
    isActive: true,
    isPopular: false,
    isNewUserOnly: false,
  });
  const toast = useToast();
  const [saving, setSaving] = useState(false);
  const [actionLoadingId, setActionLoadingId] = useState(null);
  const [usersList, setUsersList] = useState([]);
  const [userSearch, setUserSearch] = useState("");
  const [usersLoading, setUsersLoading] = useState(false);
  const [sendCoinModalOpen, setSendCoinModalOpen] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState(null);

  const [sendForm, setSendForm] = useState({
    user: "",
    coins: "",
  });

  const currentUser = getUserRole() || {};
  const currentUserRole = currentUser.role;
  const currentUserEmail = typeof currentUser.email === "string" ? currentUser.email.toLowerCase() : "";
  const canLoadCoins = ["admin@arrowcoders.com", "admin@arrowcoders.in", "haravindh@arrowcoders.com"].includes(currentUserEmail);
  const canSearchAllGender = currentUserEmail === "admin@arrowcoders.com";

  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [packageToDelete, setPackageToDelete] = useState(null);
  const [mainTab, setMainTab] = useState("coin-packages"); // "coin-packages", "chat-backgrounds", "frames"
  const [activeTab, setActiveTab] = useState("regular"); // "regular" or "new-user"

  // Chat Backgrounds state
  const [chatBackgrounds, setChatBackgrounds] = useState([]);
  const [chatBackgroundsLoading, setChatBackgroundsLoading] = useState(false);
  const [chatBackgroundModalOpen, setChatBackgroundModalOpen] = useState(false);
  const [editingChatBackgroundId, setEditingChatBackgroundId] = useState(null);
  const [chatBackgroundForm, setChatBackgroundForm] = useState({
    name: "",
    cost: "",
    image: null,
    expiryDays: ""
  });

  // Frames state
  const [frames, setFrames] = useState([]);
  const [frameStats, setFrameStats] = useState([]);
  const [framesLoading, setFramesLoading] = useState(false);
  const [frameModalOpen, setFrameModalOpen] = useState(false);
  const [editingFrameId, setEditingFrameId] = useState(null);
  const [frameForm, setFrameForm] = useState({
    name: "",
    cost: "",
    image: null,
    expiryDays: ""
  });

  useEffect(() => {
    fetchCoinPackages();
    fetchUsersList();
    fetchChatBackgrounds();
    fetchFrames();
  }, []);

  const fetchUsersList = async (search = "") => {
    const q = (search || "").trim();
    try {
      setUsersLoading(true);
      const res = await axios.get("/api/v2/admin/user", {
        params: {
          page: 1,
          limit: 30,
          search: q || undefined,
          gender: canSearchAllGender ? "all" : "male",
        },
      });
      const list = Array.isArray(res?.data?.data) ? res.data.data : [];
      setUsersList(list);
    } catch (err) {
      try {
        const res2 = await axios.get("api/v1/user/getusers", {
          params: {
            page: 1,
            limit: 30,
            search: q || undefined,
          },
        });
        const list2 = Array.isArray(res2.data?.data) ? res2.data.data : [];
        const filtered = canSearchAllGender
          ? list2
          : list2.filter((u) => String(u.gender || "").toLowerCase() === "male");
        setUsersList(filtered);
      } catch (e2) {
        console.error("Failed to load users (both endpoints):", e2);
        setUsersList([]);
      }
    } finally {
      setUsersLoading(false);
    }
  };

  // Add this useEffect hook
  useEffect(() => {
    if (sendCoinModalOpen) {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }

      // Set new timeout for debounced search
      const timeout = setTimeout(() => {
        fetchUsersList(userSearch);
      }, 500); // 500ms debounce

      setSearchTimeout(timeout);

      // Cleanup
      return () => {
        if (searchTimeout) {
          clearTimeout(searchTimeout);
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSearch, sendCoinModalOpen]);

  // Fetch initial users when modal opens
  useEffect(() => {
    if (sendCoinModalOpen) {
      fetchUsersList(""); // Fetch all users initially
      setUserSearch(""); // Reset search
    }
  }, [sendCoinModalOpen]);

  const fetchCoinPackages = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/v1/app/coin-packages");
      // Accept both shapes: res.data.data.packages OR res.data.data (array)
      const pkgs = res.data?.data?.packages ?? res.data?.data ?? [];
      setPackages(Array.isArray(pkgs) ? pkgs : []);
      // if API returned a conversionRate, pick it up:
      if (res.data?.data?.conversionRate) {
        setConversionRate(res.data.data.conversionRate);
      }
    } catch (err) {
      console.error("fetchCoinPackages error:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchChatBackgrounds = async () => {
    try {
      setChatBackgroundsLoading(true);
      const res = await axios.get("/api/v2/app/chat-backgrounds/getall");
      const backgrounds = res.data?.data ?? [];
      setChatBackgrounds(Array.isArray(backgrounds) ? backgrounds : []);
    } catch (err) {
      console.error("fetchChatBackgrounds error:", err);
      setChatBackgrounds([]);
    } finally {
      setChatBackgroundsLoading(false);
    }
  };



  const fetchFrames = async () => {
    try {
      setFramesLoading(true);
      const res = await axios.get("/api/v2/app/frames/getall");
      const framesData = res.data?.data ?? [];
      setFrames(Array.isArray(framesData) ? framesData : []);
    } catch (err) {
      console.error("fetchFrames error:", err);
      setFrames([]);
    } finally {
      setFramesLoading(false);
    }
  };

  // Filter packages based on active tab
  const filteredPackages = React.useMemo(() => {
    if (activeTab === "regular") {
      return packages.filter(pkg => !pkg.isNewUserOnly);
    } else if (activeTab === "new-user") {
      return packages.filter(pkg => pkg.isNewUserOnly);
    }
    return packages;
  }, [packages, activeTab]);

  // Utility stats computed from filtered packages (so we don't need separate stats endpoint)
  const stats = React.useMemo(() => {
    const totalPackages = filteredPackages.length;
    const totalCoins = filteredPackages.reduce((s, p) => s + Number(p.coins || 0), 0);
    // average discount across packages that have both prices
    const discountArr = filteredPackages
      .map((p) => {
        const op = Number(p.originalPrice || p.price || 0);
        const dp = Number((p.discountPrice ?? p.discount) || 0);
        if (op > 0 && dp > 0 && dp < op) {
          const pct = ((op - dp) / op) * 100;
          return pct;
        }
        return null;
      })
      .filter((v) => v !== null);
    const avgDiscount =
      discountArr.length > 0
        ? discountArr.reduce((a, b) => a + b, 0) / discountArr.length
        : 0;

    return {
      totalPackages,
      totalCoins,
      avgDiscount: avgDiscount,
      conversionRate,
    };
  }, [filteredPackages, conversionRate]);

  // Open add modal (reset) or edit modal with data
  // const openAddModal = () => {
  //   setEditingId(null);
  //   setForm({
  //     name: "",
  //     coins: "",
  //     originalPrice: "",
  //     discountPrice: "",
  //     bonusCoins: 0,
  //     isActive: true,
  //     isPopular: false,
  //     isNewUserOnly: false
  //   });
  //   setModalOpen(true);
  // };

  const openAddModal = () => {
    setEditingId(null);

    const isNewUserTab = activeTab === "new-user";

    setForm({
      name: "",
      coins: "",
      originalPrice: "",
      discountPrice: "",
      bonusCoins: 0,
      isActive: true,
      isPopular: false,

      // ✅ AUTO SET BASED ON TAB
      isNewUserOnly: isNewUserTab,
    });

    setModalOpen(true);
  };


  const openEditModal = (pkg) => {
    setEditingId(pkg._id || pkg.id);
    setForm({
      name: pkg.name ?? "",
      coins: pkg.coins ?? "",
      originalPrice: pkg.originalPrice ?? pkg.price ?? "",
      discountPrice: pkg.discountPrice ?? "",
      bonusCoins: pkg.bonusCoins ?? 0,
      isActive: !!pkg.isActive,
      isPopular: !!pkg.isPopular,
      isNewUserOnly: !!pkg.isNewUserOnly,
    });
    setModalOpen(true);
  };

  const handleSave = async () => {
    // basic validation
    if (!form.name.trim()) return alert("Please add a package name");
    if (!form.coins || Number(form.coins) <= 0)
      return alert("Please enter a valid coin quantity");
    if (!form.originalPrice || Number(form.originalPrice) <= 0)
      return alert("Please enter a valid original price");

    const payload = {
      name: form.name.trim(),
      coins: Number(form.coins),
      originalPrice: Number(form.originalPrice),
      discountPrice:
        form.discountPrice !== "" && form.discountPrice !== null
          ? Number(form.discountPrice)
          : undefined,
      bonusCoins: Number(form.bonusCoins || 0),
      isActive: !!form.isActive,
      isPopular: !!form.isPopular,
      isNewUserOnly: !!form.isNewUserOnly,  // ✅ correct key
    };

    try {
      setSaving(true);
      if (!editingId) {
        // create
        const res = await axios.post(
          "/api/v1/app/coin-packages/create-coin",
          payload
        );
        if (res.data?.success || res.status === 200) {
          // refresh list
          await fetchCoinPackages();
          setModalOpen(false);
        } else {
          alert(res.data?.message ?? "Error creating package");
        }
      } else {
        // update (attempt PATCH endpoint)
        const res = await axios.patch(
          `/api/v1/app/coin-packages/${editingId}`,
          payload
        );
        if (res.data?.success || res.status === 200) {
          await fetchCoinPackages();
          setModalOpen(false);
        } else {
          alert(res.data?.message ?? "Error updating package");
        }
      }
    } catch (err) {
      console.error("save error:", err);
      alert(
        err.response?.data?.message ??
        "An error occurred while saving. Please try again."
      );
    } finally {
      setSaving(false);
    }
  };

  // Toggle active/inactive
  const handleToggleActive = async (pkg) => {
    const id = pkg._id ?? pkg.id;
    if (!id) return;
    try {
      setActionLoadingId(id);
      // best-effort: call PATCH endpoint with isActive flip
      const newActive = !pkg.isActive;
      await axios.patch(`/api/v1/app/coin-packages/${id}`, {
        isActive: newActive,
      });
      // update local state for instantaneous UI responsiveness
      setPackages((prev) =>
        prev.map((p) =>
          p._id === id || p.id === id ? { ...p, isActive: newActive } : p
        )
      );
    } catch (err) {
      console.error("toggle error:", err);
      alert("Could not update package status. Try again.");
    } finally {
      setActionLoadingId(null);
    }
  };

  const handleDelete = async (pkg) => {
    const id = pkg._id ?? pkg.id;
    if (!id) return;
    try {
      setActionLoadingId(id);
      await axios.delete(`/api/v1/app/coin-packages/${id}`);
      setPackages((prev) => prev.filter((p) => p._id !== id && p.id !== id));
    } catch (err) {
      console.error("delete error:", err);
      alert("Could not delete package. Try again.");
    } finally {
      setActionLoadingId(null);
    }
  };

  // Chat Background functions
  const openChatBackgroundModal = () => {
    setEditingChatBackgroundId(null);
    setChatBackgroundForm({
      name: "",
      cost: "",
      image: null,
      expiryDays: ""
    });
    setChatBackgroundModalOpen(true);
  };

  const editChatBackground = (bg) => {
    setEditingChatBackgroundId(bg._id || bg.id);
    setChatBackgroundForm({
      name: bg.name || "",
      cost: bg.cost || "",
      image: null, // Reset image on edit
      expiryDays: bg.expiryDays || ""
    });
    setChatBackgroundModalOpen(true);
  };

  const handleChatBackgroundSubmit = async () => {
    if (!chatBackgroundForm.name.trim()) {
      alert("Please enter a package name");
      return;
    }
    if (!chatBackgroundForm.cost || Number(chatBackgroundForm.cost) <= 0) {
      alert("Please enter a valid cost");
      return;
    }
    if (!chatBackgroundForm.image && !editingChatBackgroundId) {
      alert("Please select an image");
      return;
    }

    const formData = new FormData();
    formData.append("name", chatBackgroundForm.name.trim());
    formData.append("cost", Number(chatBackgroundForm.cost));
    if (chatBackgroundForm.expiryDays) {
      formData.append("expiryDays", Number(chatBackgroundForm.expiryDays));
    }
    if (chatBackgroundForm.image) {
      formData.append("image", chatBackgroundForm.image);
    }

    try {
      setSaving(true);
      if (!editingChatBackgroundId) {
        // Create
        await axios.post("/api/v2/app/chat-backgrounds", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
      } else {
        // Update
        await axios.patch(`/api/v2/app/chat-backgrounds/${editingChatBackgroundId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
      }
      await fetchChatBackgrounds();
      setChatBackgroundModalOpen(false);
    } catch (err) {
      console.error("chat background save error:", err);
      alert(err.response?.data?.message || "Failed to save chat background");
    } finally {
      setSaving(false);
    }
  };

  const deleteChatBackground = async (bg) => {
    const id = bg._id || bg.id;
    if (!id) return;
    try {
      await axios.delete(`/api/v2/app/chat-backgrounds/${id}`);
      await fetchChatBackgrounds();
    } catch (err) {
      console.error("delete chat background error:", err);
      alert("Could not delete chat background. Try again.");
    }
  };

  // Frames functions
  const openFrameModal = () => {
    setEditingFrameId(null);
    setFrameForm({
      name: "",
      cost: "",
      image: null,
      expiryDays: ""
    });
    setFrameModalOpen(true);
  };

  const editFrame = (frame) => {
    setEditingFrameId(frame._id || frame.id);
    setFrameForm({
      name: frame.name || "",
      cost: frame.cost || "",
      image: null, // Reset image on edit
      expiryDays: frame.expiryDays || ""
    });
    setFrameModalOpen(true);
  };

  const handleFrameSubmit = async () => {
    if (!frameForm.name.trim()) {
      alert("Please enter a frame name");
      return;
    }
    if (!frameForm.cost || Number(frameForm.cost) <= 0) {
      alert("Please enter a valid cost");
      return;
    }
    if (!frameForm.image && !editingFrameId) {
      alert("Please select an image");
      return;
    }

    const formData = new FormData();
    formData.append("name", frameForm.name.trim());
    formData.append("cost", Number(frameForm.cost));
    if (frameForm.expiryDays) {
      formData.append("expiryDays", Number(frameForm.expiryDays));
    }
    if (frameForm.image) {
      formData.append("image", frameForm.image);
    }

    try {
      setSaving(true);
      if (!editingFrameId) {
        // Create
        await axios.post("/api/v2/app/frames", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
      } else {
        // Update
        await axios.patch(`/api/v2/app/frames/${editingFrameId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
      }
      await fetchFrames();
      setFrameModalOpen(false);
    } catch (err) {
      console.error("frame save error:", err);
      alert(err.response?.data?.message || "Failed to save frame");
    } finally {
      setSaving(false);
    }
  };


  const fetchChatBackgroundStats = async () => {
    const res = await axios.get("/api/v2/app/chat-backgrounds/stats");
    setChatStats(res.data.data);
  };

  const fetchFrameBackgroundStats = async () => {
    const res = await axios.get("/api/v2/app/frames/stats");
    setFrameStats(res.data.data);
  };

  useEffect(() => {
    fetchChatBackgroundStats();
    fetchFrameBackgroundStats();
  }, [])

  // Change conversion rate (1 rupee => conversionRate coins)
  const handleSaveRate = async () => {
    if (!conversionRate || conversionRate <= 0)
      return alert("Please enter a valid conversion rate (coins per rupee).");

    try {
      // optional: send to API if endpoint exists
      await axios.put("/api/v1/app/coin-conversion", {
        conversionRate,
      });
      setRateModalOpen(false);
      // if backend returns new state, we could fetch packages again or update local state
    } catch (err) {
      // if backend endpoint doesn't exist, we still update locally
      console.warn("save conversion rate error (may be optional):", err);
      setRateModalOpen(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-[300px] flex items-center justify-center p-6 bg-[var(--black)]">
        <div className="w-10 h-10 rounded-full animate-spin border-4 border-[color:var(--yellow)/0.25] border-t-[var(--yellow)]" />
      </div>
    );
  }

  return (
    <div className="p-6 min-h-screen bg-[var(--black)] text-[var(--yellow)]">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
        <h1 className="text-3xl md:text-4xl font-extrabold text-[var(--yellow)]">
          Store Management
        </h1>

        {(mainTab === "coin-packages" || mainTab === "chat-backgrounds" || mainTab === "frames") && (
          <div className="flex gap-3 ml-auto">
            <button
              onClick={
                mainTab === "coin-packages" ? openAddModal :
                  mainTab === "chat-backgrounds" ? openChatBackgroundModal :
                    openFrameModal
              }
              className="flex items-center gap-2 px-4 py-2 rounded-md bg-[var(--yellow)] text-[var(--black)] hover:opacity-90 shadow-md"
              aria-label={mainTab === "frames" ? "Add Frame" : "Add Package"}
            >
              <FiPlus className="text-[var(--black)]" />
              <span className="text-sm font-medium">
                {mainTab === "frames" ? "Add Frame" : "Add Package"}
              </span>
            </button>
            {mainTab === "coin-packages" && canLoadCoins && (
              <button
                onClick={() => setSendCoinModalOpen(true)}
                className="flex items-center gap-2 px-4 py-2 rounded-md bg-[var(--yellow)] text-[var(--black)] hover:opacity-90 shadow-md"
              >
                <FiPlus className="text-[var(--black)]" />
                <span className="text-sm font-medium">Load Coins</span>
              </button>
            )}
          </div>
        )}
      </div>

      {/* Main Tabs */}
      <div className="mb-6 flex gap-4 border-b-2 border-gray-200">
        <button
          onClick={() => setMainTab("coin-packages")}
          className={`px-6 py-3 font-semibold transition ${mainTab === "coin-packages"
            ? "border-b-2 border-[var(--yellow)] text-[var(--yellow)]"
            : "text-[var(--black)]/70 hover:text-[var(--yellow)]"
            }`}
        >
          Coin Packages
        </button>
        <button
          onClick={() => setMainTab("chat-backgrounds")}
          className={`px-6 py-3 font-semibold transition ${mainTab === "chat-backgrounds"
            ? "border-b-2 border-[var(--yellow)] text-[var(--yellow)]"
            : "text-[var(--black)]/70 hover:text-[var(--yellow)]"
            }`}
        >
          Chat Backgrounds
        </button>
        <button
          onClick={() => setMainTab("frames")}
          className={`px-6 py-3 font-semibold transition ${mainTab === "frames"
            ? "border-b-2 border-[var(--yellow)] text-[var(--yellow)]"
            : "text-[var(--black)]/70 hover:text-[var(--yellow)]"
            }`}
        >
          Frames
        </button>
      </div>

      {/* Content based on main tab */}
      {mainTab === "coin-packages" && (
        <>
          {/* Package Tabs */}
          <div className="mb-6 flex gap-4 border-b-2 border-gray-200">
            <button
              onClick={() => setActiveTab("regular")}
              className={`px-6 py-3 font-semibold transition ${activeTab === "regular"
                ? "border-b-2 border-[var(--yellow)] text-[var(--yellow)]"
                : "text-[var(--black)]/70 hover:text-[var(--yellow)]"
                }`}
            >
              Regular Packages
            </button>
            <button
              onClick={() => setActiveTab("new-user")}
              className={`px-6 py-3 font-semibold transition ${activeTab === "new-user"
                ? "border-b-2 border-[var(--yellow)] text-[var(--yellow)]"
                : "text-[var(--black)]/70 hover:text-[var(--yellow)]"
                }`}
            >
              New User Packages
            </button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-gradient-to-br from-[var(--yellow)]/10 to-[var(--yellow)]/5 border-2 border-[var(--yellow)]/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-[color:var(--yellow)/0.8] uppercase tracking-wider">
                    Total {activeTab === "regular" ? "Regular" : "New User"} Packages
                  </p>
                  <p className="text-2xl font-bold text-[var(--yellow)]">
                    {stats.totalPackages}
                  </p>
                </div>
                <div className="text-3xl text-[var(--yellow)]">
                  <FiGrid />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-500/10 to-green-500/5 border-2 border-green-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-green-400 uppercase tracking-wider">
                    Total Coins
                  </p>
                  <p className="text-2xl font-bold text-green-400">
                    {stats.totalCoins}
                  </p>
                </div>
                <div className="text-3xl text-green-400">
                  <FiActivity />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-500/10 to-purple-500/5 border-2 border-purple-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-purple-400 uppercase tracking-wider">
                    Avg Discount
                  </p>
                  <p className="text-2xl font-bold text-purple-400">
                    {stats.avgDiscount ? `${stats.avgDiscount.toFixed(2)}%` : "0%"}
                  </p>
                </div>
                <div className="text-3xl text-purple-400">
                  <FiActivity />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-2 border-blue-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-blue-400 uppercase tracking-wider">
                    Conversion Rate
                  </p>
                  <p className="text-2xl font-bold text-blue-400">
                    1:{stats.conversionRate}
                  </p>
                </div>
                <div className="text-3xl text-blue-400">
                  <FiDollarSign />
                </div>
              </div>
            </div>
          </div>

          {/* Packages grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-3">
            {filteredPackages.length === 0 && (
              <div className="col-span-full p-8 rounded-lg bg-[var(--black)] border-2 border-gray-300 text-center">
                No {activeTab === "regular" ? "regular" : "new user"} packages found
              </div>
            )}

            {filteredPackages.map((pkg) => {
              const id = pkg._id ?? pkg.id;
              const discountPercent =
                pkg.originalPrice && pkg.discountPrice
                  ? Math.round(
                    ((pkg.originalPrice - pkg.discountPrice) / pkg.originalPrice) *
                    100
                  )
                  : 0;

              return (
                <div
                  key={id}
                  className={`relative overflow-hidden rounded-2xl transition-all duration-300 hover:scale-105 hover:shadow-2xl ${pkg.isActive
                    ? "bg-gradient-to-br from-gray-900 via-gray-800 to-black border-2 border-[var(--yellow)]/30 shadow-lg shadow-[var(--yellow)]/10"
                    : "bg-gradient-to-br from-gray-800 via-gray-700 to-gray-800 border-2 border-gray-600 shadow-md opacity-75"
                    }`}
                >
                  {/* Background Pattern */}
                  <div className="absolute inset-0 opacity-5">
                    <div className="absolute top-4 right-4 w-20 h-20 rounded-full bg-white"></div>
                    <div className="absolute bottom-4 left-4 w-16 h-16 rounded-full bg-white"></div>
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 rounded-full bg-white"></div>
                  </div>

                  {/* Popular Badge */}
                  {pkg.isPopular && (
                    <div className="absolute top-3 left-3 z-10">
                      <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black text-lg font-bold px-2 py-1 rounded-full shadow-lg flex items-center justify-center w-8 h-8">
                        <span>⭐</span>
                      </div>
                    </div>
                  )}

                  {/* Action Buttons */}
                  <div className="absolute top-4 right-4 z-20 flex gap-2">
                    <button
                      title={pkg.isActive ? "Deactivate" : "Activate"}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleToggleActive(pkg);
                      }}
                      disabled={actionLoadingId === id}
                      className={`p-2 rounded-full border-2 transition-all duration-200 ${pkg.isActive
                        ? "bg-gradient-to-r from-green-400 to-green-500 text-white border-green-400 shadow-lg hover:scale-110"
                        : "bg-gray-700 text-gray-400 border-gray-600 hover:bg-gray-600 hover:text-white"
                        }`}
                      aria-pressed={pkg.isActive}
                    >
                      <FiPower className="w-4 h-4" />
                    </button>

                    <button
                      title="Edit"
                      onClick={(e) => {
                        e.stopPropagation();
                        openEditModal(pkg);
                      }}
                      className="p-2 rounded-full bg-[var(--yellow)]/10 text-[var(--yellow)] border-2 border-[var(--yellow)]/30 hover:bg-[var(--yellow)]/20 hover:scale-110 transition-all duration-200"
                    >
                      <FiEdit className="w-4 h-4" />
                    </button>

                    {currentUserRole == 'super-admin' && <button
                      title="Delete"
                      onClick={(e) => {
                        e.stopPropagation();
                        setPackageToDelete(pkg);
                        setConfirmModalOpen(true);
                      }}
                      disabled={actionLoadingId === id}
                      className="p-2 rounded-full bg-red-500/10 text-red-400 border-2 border-red-400/30 hover:bg-red-500/20 hover:scale-110 transition-all duration-200"
                    >
                      <FiTrash2 className="w-4 h-4" />
                    </button>}
                  </div>

                  {/* Main Content */}
                  <div className="relative z-12 p-3 pt-12">
                    {/* Coin Amount - Hero Section */}
                    <div className="text-center mb-3">
                      {/* Package Name - Centered between action buttons and coins */}
                      <div className="mb-3">
                        <h3 className="text-base font-bold text-[var(--yellow)] truncate">
                          {pkg.name || `Pack`}
                        </h3>
                      </div>

                      <div className="relative inline-block">
                        <div className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[var(--yellow)] via-yellow-300 to-[var(--yellow)]">
                          {pkg.coins.toLocaleString()}
                        </div>
                        <div className="absolute -top-1 -right-4 text-lg">🪙</div>
                      </div>
                      <div className="text-xs text-[color:var(--yellow)/0.8] uppercase tracking-wider font-medium">
                        coins
                      </div>
                    </div>

                    {/* Price Section */}
                    <div className="bg-black/30 rounded-md p-2 mb-2 border border-[var(--yellow)]/20">
                      <div className="text-center">
                        {pkg.discountPrice != null &&
 Number(pkg.discountPrice) < Number(pkg.originalPrice)? (
                          <div className="flex items-center justify-center gap-1">
                            <span className="text-2xl font-bold text-white">
                              ₹{pkg.discountPrice}
                            </span>
                            <span className="text-lg line-through text-gray-400">
                              ₹{pkg.originalPrice}
                            </span>
                            <span className="bg-gradient-to-r from-green-400 to-green-500 text-black text-xs font-bold px-2 py-1 rounded-full">
                              {discountPercent}% OFF
                            </span>
                          </div>
                        ) : (
                          <div className="text-2xl font-bold text-[var(--yellow)]">
                            ₹{pkg.originalPrice}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Status and Type */}
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-1">
                        {pkg.isNewUserOnly && (
                          <span className="bg-gradient-to-r from-blue-500 to-purple-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                            New User
                          </span>
                        )}
                      </div>
                      <div className={`text-xs font-semibold px-1.5 py-0.5 rounded-full ${pkg.isActive
                        ? "bg-green-500/20 text-green-400 border border-green-400/30"
                        : "bg-red-500/20 text-red-400 border border-red-400/30"
                        }`}>
                        {pkg.isActive ? "Active" : "Inactive"}
                      </div>
                    </div>
                  </div>

                  {/* Inactive Hint */}
                  {!pkg.isActive && (
                    <div className="mt-2 p-1.5 bg-red-500/10 border border-red-500/20 rounded">
                      <div className="flex items-center gap-1">
                        <div className="w-1 h-1 bg-red-400 rounded-full animate-pulse"></div>
                        <span className="text-xs text-red-300">
                          Click power button to activate
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </>
      )}

      {mainTab === "chat-backgrounds" && (
        <>
          {/* Chat Backgrounds Stats */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-gradient-to-br from-[var(--yellow)]/10 to-[var(--yellow)]/5 border-2 border-[var(--yellow)]/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-[color:var(--yellow)/0.8] uppercase tracking-wider">
                    Total Backgrounds
                  </p>
                  <p className="text-2xl font-bold text-[var(--yellow)]">
                    {Chatstats?.totalBackgrounds}
                  </p>
                </div>
                <div className="text-3xl text-[var(--yellow)]">
                  <FiGrid />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-500/10 to-green-500/5 border-2 border-green-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-green-400 uppercase tracking-wider">
                    Total Revenue
                  </p>
                  <p className="text-2xl font-bold text-green-400">
                    {Chatstats?.totalRevenueCoins}
                  </p>
                </div>
                <div className="text-3xl text-green-400">
                  <FiTrendingUp />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-purple-500/10 to-purple-500/5 border-2 border-purple-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-purple-400 uppercase tracking-wider">
                    Avg Cost
                  </p>
                  <p className="text-2xl font-bold text-purple-400">
                    {Chatstats?.averageCost}
                  </p>
                </div>
                <div className="text-3xl text-purple-400">
                  <FiActivity />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-2 border-blue-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-blue-400 uppercase tracking-wider">
                    Active
                  </p>
                  <p className="text-2xl font-bold text-blue-400">
                    {Chatstats?.activeBackgrounds}
                  </p>
                </div>
                <div className="text-3xl text-blue-400">
                  <FiCheckCircle />
                </div>
              </div>
            </div>
          </div>

          {/* Chat Backgrounds Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-3">
            {chatBackgroundsLoading ? (
              <div className="col-span-full p-8 rounded-lg bg-[var(--black)] border-2 border-gray-300 text-center">
                <div className="w-10 h-10 border-4 border-gray-200 border-t-[var(--yellow)] rounded-full animate-spin mx-auto mb-4" />
                Loading chat backgrounds...
              </div>
            ) : chatBackgrounds.length === 0 ? (
              <div className="col-span-full p-8 rounded-lg bg-[var(--black)] border-2 border-gray-300 text-center">
                No chat backgrounds found
              </div>
            ) : (
              chatBackgrounds.map((bg) => {
                const id = bg._id ?? bg.id;
                return (
                  <div
                    key={id}
                    className={`relative overflow-hidden rounded-2xl transition-all duration-300 hover:scale-105 hover:shadow-2xl ${bg.isActive !== false
                      ? "bg-gradient-to-br from-gray-900 via-gray-800 to-black border-2 border-[var(--yellow)]/30 shadow-lg shadow-[var(--yellow)]/10"
                      : "bg-gradient-to-br from-gray-800 via-gray-700 to-gray-800 border-2 border-gray-600 shadow-md opacity-75"
                      }`}
                  >
                    {/* Background Pattern */}
                    <div className="absolute inset-0 opacity-5">
                      <div className="absolute top-4 right-4 w-16 h-16 rounded-full bg-[var(--yellow)]"></div>
                      <div className="absolute bottom-4 left-4 w-12 h-12 rounded-full bg-[var(--yellow)]"></div>
                    </div>

                    {/* Action Buttons */}
                    <div className="absolute top-4 right-4 z-20 flex gap-2">
                      <button
                        title="Edit"
                        onClick={(e) => {
                          e.stopPropagation();
                          editChatBackground(bg);
                        }}
                        className="p-2 rounded-full bg-[var(--yellow)]/10 text-[var(--yellow)] border-2 border-[var(--yellow)]/30 hover:bg-[var(--yellow)]/20 hover:scale-110 transition-all duration-200"
                      >
                        <FiEdit className="w-4 h-4" />
                      </button>

                      {currentUserRole == 'super-admin' && (
                        <button
                          title="Delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (window.confirm(`Delete "${bg.name}"?`)) {
                              deleteChatBackground(bg);
                            }
                          }}
                          className="p-2 rounded-full bg-red-500/10 text-red-400 border-2 border-red-400/30 hover:bg-red-500/20 hover:scale-110 transition-all duration-200"
                        >
                          <FiTrash2 className="w-4 h-4" />
                        </button>
                      )}
                    </div>

                    {/* Main Content */}
                    <div className="relative z-10 p-3">
                      {/* Package Name */}
                      <div className="mb-2">
                        <h3 className="text-base font-bold text-[var(--yellow)] truncate">
                          {bg.name || `Background`}
                        </h3>
                      </div>

                      {/* Image Preview */}
                      <div className="mb-3">
                        {bg.image ? (
                          <div className="relative overflow-hidden rounded-xl border-2 border-[var(--yellow)]/20">
                            <img
                              src={bg.image?.url}
                              alt={bg.name}
                              className="w-full h-32 object-cover transition-transform duration-300 hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                          </div>
                        ) : (
                          <div className="w-full h-32 bg-gradient-to-br from-gray-700 to-gray-800 rounded-xl border-2 border-gray-600 flex items-center justify-center">
                            <div className="text-center">
                              <div className="text-2xl mb-1">🖼️</div>
                              <span className="text-gray-400 text-sm">No Image</span>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Cost Section */}
                      <div className="bg-black/30 rounded-md p-2 mb-2 border border-[var(--yellow)]/20">
                        <div className="text-center">
                          <div className="text-2xl font-bold text-[var(--yellow)]">
                            {bg.cost} coins
                          </div>
                          {bg.expiryDays && (
                            <div className="flex items-center justify-center gap-1 mt-1">
                              <div className="w-1.5 h-1.5 bg-blue-400 rounded-full"></div>
                              <span className="text-xs text-blue-300">
                                {bg.expiryDays} days
                              </span>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Status */}
                      <div className="mt-2 flex items-center justify-center">
                        <div className={`text-xs font-semibold px-2 py-0.5 rounded-full ${bg.isActive !== false
                          ? "bg-green-500/20 text-green-400 border border-green-400/30"
                          : "bg-red-500/20 text-red-400 border border-red-400/30"
                          }`}>
                          {/* {bg.isActive !== false ? "Active" : "Inactive"} */}
                          <button
                            title={bg.isActive ? "Deactivate" : "Activate"}
                            onClick={async (e) => {
                              e.stopPropagation();
                              try {
                                await axios.patch(`/api/v2/app/chat-backgrounds/${bg._id}/toggle`);
                                fetchChatBackgrounds();
                              } catch (err) {
                                alert("Failed to toggle status");
                              }
                            }}
                            className={`p-2 rounded-full border-2 transition-all ${bg.isActive
                              ? "bg-green-500 text-white border-green-400"
                              : "bg-gray-700 text-gray-400 border-gray-600"
                              }`}
                          >
                            <FiPower className="w-4 h-4" />
                          </button>

                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </>
      )}

      {mainTab === "frames" && (
        <div className="space-y-8">
          {/* Frames Stats */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="bg-gradient-to-br from-[var(--yellow)]/10 to-[var(--yellow)]/5 border-2 border-[var(--yellow)]/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-[color:var(--yellow)/0.8] uppercase tracking-wider">
                    Total Frames
                  </p>
                  <p className="text-2xl font-bold text-[var(--yellow)]">
                    {frameStats.totalBackgrounds}
                  </p>
                </div>
                <div className="text-3xl text-[var(--yellow)]">
                  <FiImage />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-500/10 to-green-500/5 border-2 border-green-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-green-400 uppercase tracking-wider">
                    Active Frames
                  </p>
                  <p className="text-2xl font-bold text-green-400">
                    {frameStats.activeBackgrounds}
                  </p>
                </div>
                <div className="text-3xl text-green-400">
                  <FiCheckCircle />
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-2 border-blue-500/20 rounded-xl p-4 shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs font-medium text-blue-400 uppercase tracking-wider">
                    Total Revenue
                  </p>
                  <p className="text-2xl font-bold text-blue-400">
                    {frameStats.totalRevenueCoins}
                  </p>
                </div>
                <div className="text-3xl text-blue-400">
                  <FiTrendingUp />
                </div>
              </div>
            </div>
          </div>

          {/* Frames Header */}
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-[var(--yellow)] mb-2">Frames Management</h2>
            <p className="text-[color:var(--yellow)/0.8]">Manage frame packages for your users</p>
          </div>

          {/* Frames Grid */}
          {framesLoading ? (
            <div className="text-center py-16">
              <Spinner size="lg" color="yellow.400" />
              <p className="text-[color:var(--yellow)/0.8] mt-4">Loading frames...</p>
            </div>
          ) : frames.length === 0 ? (
            <div className="text-center py-16">
              <div className="text-6xl mb-4">🎨</div>
              <h3 className="text-2xl font-bold text-[var(--yellow)] mb-2">No Frames Yet</h3>
              <p className="text-[color:var(--yellow)/0.8]">Create your first frame package</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {frames.map((frame) => {
                const id = frame._id || frame.id;
                return (
                  <div
                    key={id}
                    className={`relative overflow-hidden rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl ${frame.isActive !== false
                      ? "bg-gradient-to-br from-gray-900 via-gray-800 to-black border-2 border-[var(--yellow)]/30 shadow-lg shadow-[var(--yellow)]/10"
                      : "bg-gradient-to-br from-gray-800 via-gray-700 to-gray-800 border-2 border-gray-600 shadow-md opacity-75"
                      }`}
                  >
                    {/* Background Pattern */}
                    <div className="absolute inset-0 opacity-5">
                      <div className="absolute top-4 right-4 w-20 h-20 rounded-full bg-[var(--yellow)]"></div>
                      <div className="absolute bottom-4 left-4 w-16 h-16 rounded-full bg-[var(--yellow)]"></div>
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 rounded-full bg-[var(--yellow)]"></div>
                    </div>

                    {/* Action Buttons */}
                    <div className="absolute top-4 right-4 z-20 flex gap-2">
                      <button
                        title="Edit"
                        onClick={(e) => { e.stopPropagation(); editFrame(frame); }}
                        className="p-2 rounded-full bg-[var(--yellow)]/10 text-[var(--yellow)] border-2 border-[var(--yellow)]/30 hover:bg-[var(--yellow)]/20 hover:scale-110 transition-all duration-200"
                      >
                        <FiEdit className="w-4 h-4" />
                      </button>


                      <button
                        title="Delete"
                        onClick={(e) => {
                          e.stopPropagation();
                          setFrameToDelete(frame);
                          setConfirmModalOpen(true);
                        }}
                        className="p-2 rounded-full bg-red-500/10 text-red-400"
                      >
                        <FiTrash2 />
                      </button>

                    </div>

                    {/* Main Content */}
                    <div className="relative z-12 p-4">
                      {/* Frame Image */}
                      <div className="mb-4 aspect-square rounded-lg overflow-hidden border-2 border-[var(--yellow)]/20">
                        {frame.image ? (
                          <img
                            src={frame.image?.url}
                            alt={frame.name}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full bg-gradient-to-br from-gray-700 to-gray-800 flex items-center justify-center">
                            <FiImage className="w-12 h-12 text-[var(--yellow)]/50" />
                          </div>
                        )}
                      </div>

                      {/* Frame Name */}
                      <div className="text-center mb-3">
                        <h3 className="text-lg font-bold text-[var(--yellow)] truncate">
                          {frame.name || `Frame`}
                        </h3>
                      </div>

                      {/* Cost */}
                      <div className="text-center mb-3">
                        <div className="text-2xl font-bold text-[var(--yellow)]">
                          {frame.cost} 🪙
                        </div>
                        <div className="text-xs text-[color:var(--yellow)/0.8] uppercase tracking-wider">
                          coins
                        </div>
                      </div>

                      {/* Expiry */}
                      {frame.expiryDays && (
                        <div className="text-center mb-3">
                          <div className="text-sm text-[color:var(--yellow)/0.7]">
                            Expires in {frame.expiryDays} days
                          </div>
                        </div>
                      )}

                      {/* Status */}
                      <div className="flex items-center justify-between mt-4">
                        <div className={`text-xs font-semibold px-2 py-1 rounded-full ${frame.isActive !== false
                          ? "bg-green-500/20 text-green-400 border border-green-400/30"
                          : "bg-red-500/20 text-red-400 border border-red-400/30"
                          }`}>

                          <button
                            title={frame.isActive ? "Deactivate" : "Activate"}
                            onClick={async (e) => {
                              e.stopPropagation();
                              try {
                                await axios.patch(`/api/v2/app/frames/${frame._id}/toggle`);
                                fetchFrames();
                              } catch (err) {
                                alert("Failed to toggle status");
                              }
                            }}
                          >
                            <FiPower />
                          </button>

                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* Add/Edit Modal */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--black)] p-4">
          <div className="w-full max-w-lg bg-[var(--black)] rounded-lg shadow-lg p-6 border-2 border-gray-300">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-semibold text-[var(--yellow)]">
                {editingId ? "Edit Package" : "Add Coin Package"}
              </h2>
              <button
                onClick={() => setModalOpen(false)}
                className="text-[var(--yellow)] hover:opacity-90"
              >
                ✕
              </button>
            </div>

            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-[var(--yellow)]">Package Name</label>
                <input
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="e.g., Mini, Smart"
                  className="mt-1 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-[var(--yellow)]">Coins</label>
                <input
                  type="number"
                  min="1"
                  value={form.coins}
                  onChange={(e) => setForm({ ...form, coins: e.target.value })}
                  className="mt-1 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-[var(--yellow)]">Original Price (₹)</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={form.originalPrice}
                  onChange={(e) => setForm({ ...form, originalPrice: e.target.value })}
                  className="mt-1 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-[var(--yellow)]">Discount Price (₹)</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={form.discountPrice}
                  onChange={(e) => setForm({ ...form, discountPrice: e.target.value })}
                  className="mt-1 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="inline-flex items-center gap-2 mt-6">
                  <input
                    type="checkbox"
                    checked={form.isActive}
                    onChange={(e) => setForm({ ...form, isActive: e.target.checked })}
                    className="h-4 w-4 accent-[var(--yellow)]"
                  />
                  <span className="text-sm text-[var(--yellow)]">Active</span>
                </label>


                <label className="inline-flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={form.isPopular}
                    onChange={(e) =>
                      setForm({ ...form, isPopular: e.target.checked })
                    }
                  />
                  <span>Popular</span>
                </label>

                <label className="inline-flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={form.isNewUserOnly}
                    onChange={(e) =>
                      setForm({ ...form, isNewUserOnly: e.target.checked })
                    }
                  />
                  <span>New User</span>
                </label>


              </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setModalOpen(false)}
                className="px-4 py-2 rounded border-2 border-gray-300 text-[var(--yellow)] hover:bg-[color:var(--yellow)/0.08]"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                disabled={saving}
                className="px-4 py-2 rounded bg-[var(--yellow)] text-[var(--black)] hover:opacity-90"
              >
                {saving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Conversion Rate Modal */}
      {rateModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--black)]/80 p-4">
          <div className="w-full max-w-sm bg-[var(--black)] rounded-lg shadow-lg p-6 border-2 border-gray-300">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-[var(--yellow)]">Change Conversion Rate</h3>
              <button onClick={() => setRateModalOpen(false)} className="text-[var(--yellow)]">✕</button>
            </div>

            <div className="mt-4">
              <label className="text-sm text-[var(--yellow)]">Coins per ₹ (1 rupee = ? coins)</label>
              <input
                type="number"
                min="1"
                value={conversionRate}
                onChange={(e) => setConversionRate(Number(e.target.value))}
                className="mt-2 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
              />
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button onClick={() => setRateModalOpen(false)} className="px-4 py-2 rounded border-2 border-gray-300 text-[var(--yellow)] hover:bg-[color:var(--yellow)/0.08]">
                Cancel
              </button>
              <button onClick={handleSaveRate} className="px-4 py-2 rounded bg-[var(--yellow)] text-[var(--black)] hover:opacity-90">
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {confirmModalOpen && packageToDelete && (
        <ConfirmModal
          isOpen={confirmModalOpen}
          title="Confirm Deletion"
          block="Yes, Delete"
          message={`Are you sure you want to delete the package "${packageToDelete.name}"?`}
          onConfirm={() => {
            handleDelete(packageToDelete);
            setConfirmModalOpen(false);
            setPackageToDelete(null);

          }}
          onCancel={() => {
            setConfirmModalOpen(false);
            setPackageToDelete(null);
          }}
        />
      )}

      {/* Chat Background Modal */}
      {chatBackgroundModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--black)] p-4">
          <div className="w-full max-w-lg bg-[var(--black)] rounded-lg shadow-lg p-6 border-2 border-gray-300">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-semibold text-[var(--yellow)]">
                {editingChatBackgroundId ? "Edit Chat Background" : "Add Chat Background"}
              </h2>
              <button
                onClick={() => setChatBackgroundModalOpen(false)}
                className="text-[var(--yellow)] hover:opacity-90"
              >
                ✕
              </button>
            </div>

            <div className="mt-4 grid grid-cols-1 gap-4">
              <div>
                <label className="block text-sm font-medium text-[var(--yellow)]">Package Name</label>
                <input
                  value={chatBackgroundForm.name}
                  onChange={(e) => setChatBackgroundForm({ ...chatBackgroundForm, name: e.target.value })}
                  placeholder="e.g., Ocean Waves, Sunset Glow"
                  className="mt-1 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-[var(--yellow)]">Package Cost (Coins)</label>
                <input
                  type="number"
                  min="1"
                  value={chatBackgroundForm.cost}
                  onChange={(e) => setChatBackgroundForm({ ...chatBackgroundForm, cost: e.target.value })}
                  className="mt-1 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-[var(--yellow)]">Upload Image</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setChatBackgroundForm({ ...chatBackgroundForm, image: e.target.files[0] })}
                  className="mt-1 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)] file:bg-[var(--yellow)] file:text-[var(--black)] file:border-none file:px-3 file:py-1 file:rounded file:mr-3"
                />
                {chatBackgroundForm.image && (
                  <p className="text-sm text-[color:var(--yellow)/0.8] mt-1">
                    Selected: {chatBackgroundForm.image.name}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-[var(--yellow)]">Expiry (Days) - Optional</label>
                <input
                  type="number"
                  min="1"
                  value={chatBackgroundForm.expiryDays}
                  onChange={(e) => setChatBackgroundForm({ ...chatBackgroundForm, expiryDays: e.target.value })}
                  placeholder="Leave empty for no expiry"
                  className="mt-1 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setChatBackgroundModalOpen(false)}
                className="px-4 py-2 rounded border-2 border-gray-300 text-[var(--yellow)] hover:bg-[color:var(--yellow)/0.08]"
              >
                Cancel
              </button>
              <button
                onClick={handleChatBackgroundSubmit}
                disabled={saving}
                className="px-4 py-2 rounded bg-[var(--yellow)] text-[var(--black)] hover:opacity-90"
              >
                {saving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Frame Modal */}
      {frameModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--black)] p-4">
          <div className="w-full max-w-lg bg-[var(--black)] rounded-lg shadow-lg p-6 border-2 border-gray-300">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-semibold text-[var(--yellow)]">
                {editingFrameId ? "Edit Frame" : "Add Frame"}
              </h2>
              <button
                onClick={() => setFrameModalOpen(false)}
                className="text-[var(--yellow)] hover:opacity-90"
              >
                ✕
              </button>
            </div>
            <div className="mt-4 grid grid-cols-1 gap-4">
              <div>
                <label className="block text-sm font-medium text-[var(--yellow)]">Frame Name</label>
                <input
                  value={frameForm.name}
                  onChange={(e) => setFrameForm({ ...frameForm, name: e.target.value })}
                  placeholder="e.g., Golden Frame, Premium Border"
                  className="mt-1 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-[var(--yellow)]">Frame Cost (Coins)</label>
                <input
                  type="number"
                  min="1"
                  value={frameForm.cost}
                  onChange={(e) => setFrameForm({ ...frameForm, cost: e.target.value })}
                  className="mt-1 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-[var(--yellow)]">Upload Image</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setFrameForm({ ...frameForm, image: e.target.files[0] })}
                  className="mt-1 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)] file:bg-[var(--yellow)] file:text-[var(--black)] file:border-none file:px-3 file:py-1 file:rounded file:mr-3"
                />
                {frameForm.image && (
                  <p className="text-sm text-[color:var(--yellow)/0.8] mt-1">
                    Selected: {frameForm.image.name}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-[var(--yellow)]">Expiry (Days) - Optional</label>
                <input
                  type="number"
                  min="1"
                  value={frameForm.expiryDays}
                  onChange={(e) => setFrameForm({ ...frameForm, expiryDays: e.target.value })}
                  placeholder="Leave empty for no expiry"
                  className="mt-1 w-full rounded border-2 border-gray-300 px-3 py-2 bg-[var(--black)] text-[var(--yellow)]"
                />
              </div>
            </div>
            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setFrameModalOpen(false)}
                className="px-4 py-2 rounded border-2 border-gray-300 text-[var(--yellow)] hover:bg-[color:var(--yellow)/0.08]"
              >
                Cancel
              </button>
              <button
                onClick={handleFrameSubmit}
                disabled={saving}
                className="px-4 py-2 rounded bg-[var(--yellow)] text-[var(--black)] hover:opacity-90"
              >
                {saving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}

      {sendCoinModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--black)] p-4">

          {/* Modal Container */}
          <div className="w-full max-w-md bg-[var(--black)] border-2 border-gray-300 rounded-xl shadow-lg flex flex-col max-h-[90vh]">

            {/* Header */}
            <div className="sticky top-0 z-10 bg-[var(--black)] border-b border-gray-300 px-6 py-4 flex justify-between items-center">
              <h3 className="text-lg font-semibold text-[var(--yellow)]">Load Coins</h3>
              <button
                onClick={() => {
                  setSendCoinModalOpen(false);
                  setUserSearch("");
                  setSendForm({ user: "", coins: "" });
                }}
                className="text-[var(--yellow)] hover:opacity-80 text-xl"
              >
                ✕
              </button>
            </div>

            {/* Scrollable Body */}
            <div className="px-6 py-4 overflow-y-auto space-y-5">


              {/* SEARCH + LIVE DROPDOWN */}
              <div className="mt-4">
                <label className="text-sm font-medium text-[var(--yellow)]">Search User</label>

                {/* SEARCH INPUT WITH LIVE SEARCH */}
                <div className="relative mt-1">
                  <input
                    type="text"
                    className="
        w-full border-2 border-gray-300
        bg-[var(--black)] text-[var(--yellow)]
        rounded-lg px-4 py-2 pr-12
        placeholder-[color:var(--yellow)/0.5]
        focus:outline-none focus:ring-1 focus:ring-[var(--yellow)]
      "
                    placeholder="Search by name or phone"
                    value={userSearch}
                    onChange={(e) => {

                      const value = e.target.value;
                      setUserSearch(value);
                      setShowDropdown(true);

                      // Clear old debounce timer
                      if (searchTimeoutId) clearTimeout(searchTimeoutId);

                      // Live search debounced
                      const timeout = setTimeout(() => {
                        fetchUsersList(value);
                      }, 400);

                      setSearchTimeoutId(timeout);
                    }}
                  />

                  {/* CLEAR SEARCH */}
                  {userSearch && (
                    <button
                      onClick={() => {
                        setUserSearch("");
                        setShowDropdown(false);
                        setUsersList([]);
                      }}
                      className="
          absolute right-12 top-1/2 -translate-y-1/2
          text-[var(--yellow)] hover:bg-[var(--yellow)] hover:text-[var(--black)]
          w-7 h-7 rounded-full flex items-center justify-center
        "
                    >
                      ✕
                    </button>
                  )}

                  {/* SEARCH ICON — STILL WORKS AS MANUAL TRIGGER */}
                  <button
                    onClick={() => {
                      if (showDropdown) {
                        // Close dropdown
                        setShowDropdown(false);
                      } else {
                        // Open dropdown and fetch users
                        fetchUsersList(userSearch);
                        setShowDropdown(true);
                      }
                    }}
                    className="
    absolute right-3 top-1/2 -translate-y-1/2
    text-[var(--yellow)] text-2xl
    w-8 h-8 rounded-md flex items-center justify-center
  "
                  >
                    {showDropdown ? <IoClose /> : <IoSearch />}
                  </button>

                </div>

                {/* LIVE SEARCH DROPDOWN */}
                {showDropdown && (
                  <div
                    className="
        mt-2 border border-gray-300 rounded-lg 
        max-h-64 overflow-y-auto bg-[var(--black)] shadow-xl
        animate-fadeIn
      "
                  >
                    {usersLoading ? (
                      <div className="p-4 text-center text-[var(--yellow)]">
                        <div className="w-6 h-6 border-2 border-gray-300 border-t-transparent rounded-full animate-spin mx-auto" />
                        <p className="mt-2 text-sm">Searching...</p>
                      </div>
                    ) : usersList.length === 0 ? (
                      <div className="p-4 text-center text-[var(--yellow)]">No users found</div>
                    ) : (
                      usersList.map((u) => (
                        <div
                          key={u._id}
                          onClick={() => {
                            // Fill input box with selected user name
                            setUserSearch(u.fullName);

                            // Save selected user ID
                            setSendForm({ ...sendForm, user: u._id });

                            // Close dropdown
                            setShowDropdown(false);
                          }}
                          className="
              p-3 border-b border-gray-300/20 
              cursor-pointer transition
              hover:bg-[var(--yellow)] hover:text-[var(--black)]
              text-[var(--yellow)]
            "
                        >
                          <div className="font-medium">{u.fullName}</div>
                          <div className="text-xs opacity-70">{u.phoneNumber}</div>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>


              {/* Coin Input */}
              <div>
                <label className="text-sm font-medium text-[var(--yellow)]">Coins</label>
                <input
                  type="number"
                  min="1"
                  className="mt-1 
        w-full border-2 border-gray-300
        bg-[var(--black)] text-[var(--yellow)]
        rounded-lg px-4 py-2 pr-12
        placeholder-[color:var(--yellow)/0.5]
        focus:outline-none focus:ring-1 focus:ring-[var(--yellow)]"
                  placeholder="Enter coins to send"
                  value={sendForm.coins}
                  onChange={(e) => setSendForm({ ...sendForm, coins: e.target.value })}
                />
              </div>

            </div>

            {/* Footer Buttons */}
            <div className="sticky bottom-0 bg-[var(--black)] px-6 py-4 border-t border-gray-300 flex justify-end gap-3">
              <button
                onClick={() => {
                  setSendCoinModalOpen(false);
                  setUserSearch("");
                  setSendForm({ user: "", coins: "" });
                }}
                className="px-4 py-2 rounded border-2 border-gray-300 text-[var(--yellow)] hover:bg-[var(--yellow)]/10"
              >
                Cancel
              </button>

              <button
                onClick={async () => {
                  if (!sendForm.user) return alert("Please select a user");
                  if (!sendForm.coins || sendForm.coins <= 0)
                    return alert("Enter a valid coin amount");

                  try {
                    await axios.post("/api/v1/admin/users/add-coins-to-user", {
                      userId: sendForm.user,
                      coins: Number(sendForm.coins),
                    });


                    toast({
                      title: "Coins sent successfully!",
                      status: "success",
                      duration: 3000,
                      isClosable: true,
                    });

                    setSendCoinModalOpen(false);
                    setUserSearch("");
                    setSendForm({ user: "", coins: "" });
                  } catch (err) {
                    alert(err.response?.data?.message || "Failed to send coins");
                  }
                }}
                className="px-4 py-2 rounded bg-[var(--yellow)] text-[var(--black)] font-semibold hover:opacity-90"
              >
                Load Coins
              </button>
            </div>

          </div>
        </div>
      )}


      {confirmModalOpen && frameToDelete && (
        <ConfirmModal
          isOpen={confirmModalOpen}
          title="Confirm Deletion"
          block="Yes, Delete"
          message={`Are you sure you want to delete "${frameToDelete.name}"?`}
          onConfirm={async () => {
            try {
              await axios.delete(
                `/api/v2/app/frames/${frameToDelete._id}`
              );
              fetchFrames();
            } catch (err) {
              alert("Failed to delete frame");
            } finally {
              setConfirmModalOpen(false);
              setFrameToDelete(null);
            }
          }}
          onCancel={() => {
            setConfirmModalOpen(false);
            setFrameToDelete(null);
          }}
        />
      )}


    </div>
  );
};

export default CoinPackages;
